define('apps/check-requirements/models/requirement',[
    ], function(){

    'use strict';

    var Requirement = Backbone.Model.extend({

        "initialize": function(){
            this.getOSInfo();
            this.getReaderInfo();
            this.getBrowser();
            this.getSupportedInfo();
            this.cleanBrowserName();
        },

        "defaults": {
            "browser": "",
            "pdfReader": "None Detected",
            "readerVersion": -1,
            "readerInstalled": false,
            "os": "",
            "minReqs": {
                "ff": 44,
                "safari": 9.0,
                "edge": 38,
                "adobeReader": 10
            },
            "readerSupported": false,
            "browserSupported": false,
            "browserFriendly": 'other',
            "browserVersion": "",
            "passedRequirements": false

        },

        "getReaderInfo": function() {
            var readerVersion,
                readerInstalled,
                readerSupported,
                version = 0;
            if (window.ActiveXObject) {
              var control = null;
              try {
                // AcroPDF.PDF is used by version 7 and later
                control = new ActiveXObject('AcroPDF.PDF');
              } catch (e) {
                // Do nothing
              }
              if (!control) {
                try {
                  // PDF.PdfCtrl is used by version 6 and earlier
                  control = new ActiveXObject('PDF.PdfCtrl');
                } catch (e) {
                  return;
                }
              }
              if (control) {
                /* eslint new-cap:0 */
                version = control.GetVersions().split(',');
                version = version[0].split('=');
                this.set({
                    "pdfReader": 'Adobe Reader'
                });
                readerVersion = parseFloat(version[1]);
                readerInstalled = true;
              }
            } else if (navigator.plugins) {
               var plugins = navigator.plugins;

               for (var i = 0; i < plugins.length; i++) {
                   if (plugins[i].name === 'Adobe Reader' || plugins[i].name === 'Adobe Acrobat' || plugins[i].name.indexOf('Adobe PDF') !== -1) {
                    this.set({
                        "pdfReader": 'Adobe Reader'
                    });
                       readerVersion = parseFloat(plugins[i].version) || 8.0;
                       readerInstalled = true;
                   } else if (plugins[i].name === 'Chrome PDF Viewer') {
                    this.set({
                        "pdfReader": 'Chrome PDF Viewer'
                    });
                       readerVersion = '';
                       readerInstalled = true;
                   }
                    if (this.get("os") === 'Macintosh' && this.get("browser") !== 'Chrome') { // mac has pdf viewer built in
                        this.set({
                            "pdfReader": "Mac Built-In PDF Viewer"
                        });
                       readerVersion = '';
                       readerInstalled = true;
                    }
                }
            }
        },

        "getOSInfo": function() {
            var agent = navigator.userAgent.toLowerCase();
            if (agent.indexOf('win') !== -1) {
                this.set({
                    "os": 'Windows'
                });
            } else if (agent.indexOf('mac') !== -1) {
                this.set({
                    "os": 'Macintosh'
                });
            } else if (agent.indexOf('linux') !== -1) {
                this.set({
                    "os": 'Linux'
                });
            } else if (agent.indexOf('unix') !== -1) {
                this.set({
                    "os": 'Unix'
                });
            } else {
                this.set({
                    "os": 'Other'
                });
            }
        },

        "getBrowser": function(){
            var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])){
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return this.set({
                    'browser': 'IE',
                    'browserVersion': (tem[1] || '')
                });
                }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR\/(\d+)/);
                if (tem !== null) {
                    return this.set({
                        'browser': 'Opera',
                        'browserVersion': tem[1]
                    });
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) !== null) {M.splice(1, 1, tem[1]);}
            this.set({
                "browser": M[0],
                "browserVersion": M[1]
            });
        },

        "cleanBrowserName": function(){
            var userBrowserName = this.get("browser");
            if (userBrowserName === "MSIE") {
                this.set({
                    'browser': 'Internet Explorer'
                });
            }
        },

        "getSupportedInfo": function() {

            var userBrowser = this.get("browser"),
            userBrowserVersion = this.get("browserVersion"),
            minimumRequirements = this.get("minReqs"),
            userReaderVersion = this.get("readerVersion"),
            userReader = this.get("reader"),
            userReaderVersion = this.get("readerVersion");

            if ((userBrowser === 'Chrome') ||
                (userBrowser === 'Opera') ||
                (userBrowser === 'MSIE' && userBrowserVersion >= minimumRequirements.ie) ||
                (userBrowser === 'Firefox' && userBrowserVersion >= minimumRequirements.ff) ||
                (userBrowser === 'Safari' && userBrowserVersion >= minimumRequirements.safari) ||
                (userBrowser === 'Edge' && userBrowserVersion >= minimumRequirements.edge)){
                this.set({
                    'browserSupported': true
                });
            } else {
                this.set({
                    'browserSupported': false
                });
            }
            this.set({
                'readerSupported': userReader === 'Adobe Reader' && userReaderVersion >= minimumRequirements.adobeReader || userReader !== 'Adobe Reader' && userReader !== ''
            });

            if (this.get('browserSupported') === true && this.get('readerSupported') === true){
                this.set({
                    'passedRequirements': true
                });
            } else {
                this.set({
                    'passedRequirements': false
                });
            }
            if (this.get('pdfReader') === "None Detected") {
            this.set({
                'readerSupported': false
                });
            }
        }
    });

    return Requirement;
});

